var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMyBookingEmptyInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 38,
    viewBox: "0 0 61 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8339 17.0123C54.904 16.7134 54.941 16.4016 54.941 16.0811C54.941 13.8539 53.1499 12.0483 50.9403 12.0483C48.7308 12.0483 46.9396 13.8539 46.9396 16.0811C46.9396 16.4016 46.9767 16.7134 47.0468 17.0123H33.2915C32.8745 18.7906 31.2895 20.114 29.3979 20.114C27.5064 20.114 25.9214 18.7906 25.5044 17.0123",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2709 16.9098C33.3409 16.6109 33.378 16.2991 33.378 15.9786C33.378 13.7514 31.5868 11.9458 29.3773 11.9458C27.1678 11.9458 25.3766 13.7514 25.3766 15.9786C25.3766 16.2991 25.4137 16.6109 25.4837 16.9098L24.7611 16.9093C23.0614 16.9093 21.6836 15.5204 21.6836 13.8071V11.3769C21.6836 10.9687 21.9311 10.5993 22.314 10.4358L29.9629 7.17018C30.1834 7.09255 30.3775 6.95328 30.5224 6.76862L33.746 2.66179C34.6799 1.47198 36.1023 0.778076 37.6074 0.778076H47.2646C49.2848 0.778076 51.1001 2.022 51.8433 3.91565L53.0739 7.05133L57.6483 9.55609C58.2431 9.88177 58.6134 10.5094 58.6134 11.1917V13.8071C58.6134 15.5204 57.2355 16.9093 55.5359 16.9093L54.8132 16.9098C54.3962 18.6881 52.8113 20.0115 50.9197 20.0115C49.0281 20.0115 47.4431 18.6881 47.0261 16.9098",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0975 30.9976C39.7298 28.4638 37.5188 26.516 34.8462 26.516C32.1736 26.516 29.9626 28.4638 29.5949 30.9976M40.0975 30.9976C41.9678 30.9976 43.3302 30.9976 44.1847 30.9976M40.0975 30.9976C40.1329 31.2415 40.1512 31.4909 40.1512 31.7445C40.1512 34.6321 37.7761 36.973 34.8462 36.973C31.9163 36.973 29.5412 34.6321 29.5412 31.7445C29.5412 31.4909 29.5595 31.2415 29.5949 30.9976M29.5949 30.9976H18.9312V20.5405H58.9585C59.7956 20.5405 60.4742 21.2093 60.4742 22.0344V29.5037C60.4742 30.3287 59.7956 30.9976 58.9585 30.9976C57.0364 30.9976 55.5948 30.9976 54.6337 30.9976",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.431 37.4865C52.6256 37.4865 55.2155 34.9575 55.2155 31.8379C55.2155 28.7182 52.6256 26.1892 49.431 26.1892C46.2363 26.1892 43.6465 28.7182 43.6465 31.8379C43.6465 34.9575 46.2363 37.4865 49.431 37.4865Z",
    stroke: "#FFD4A3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8092 31.0163C15.4371 28.4904 13.1998 26.5487 10.4953 26.5487C7.79093 26.5487 5.55361 28.4904 5.18152 31.0163L0.525879 31.0162V19.1027L9.72846 7.18921H18.9311V31.0162L15.8092 31.0163ZM15.8092 31.0163C15.845 31.2595 15.8635 31.5081 15.8635 31.7608C15.8635 34.6394 13.4601 36.973 10.4953 36.973C7.53059 36.973 5.12717 34.6394 5.12717 31.7608C5.12717 31.5081 5.14571 31.2595 5.18152 31.0163",
    stroke: "#FFD4A3",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMyBookingEmptyInfo);
export default __webpack_public_path__ + "static/media/ico_my_booking_empty_info.ada83915c22e5666adc21d392a37ec4e.svg";
export { ForwardRef as ReactComponent };